import PropTypes from 'prop-types';

import Box, { BoxProps as MuiBoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import WaitingRoom from '../../components/WaitingRoom';
import Helmet from '../../components/Helmet';

export interface HomeProps extends MuiBoxProps {}

export const WaitingRoomPage = ({ className }: HomeProps) => {
  return (
    <>
      <Helmet />
      <WaitingRoom />
    </>
  );
};

WaitingRoomPage.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

WaitingRoomPage.defaultProps = {
  children: null,
  className: null,
};

export default styled<any>(WaitingRoomPage)(
  ({ theme }) => `
`,
);
